// JsFromRoutes CacheKey b54d7ef44ac536f1b638d7b70eeadad4
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from 'utils/js_from_routes_client'

export default {
  currentBenefits: /* #__PURE__ */ definePathHelper('get', '/broker/prospects/:prospect_id/quotes/:quote_id/current_benefits'),
  explore: /* #__PURE__ */ definePathHelper('get', '/broker/prospects/:prospect_id/quotes/:quote_id/explore'),
  processing: /* #__PURE__ */ definePathHelper('get', '/broker/prospects/:prospect_id/quotes/:quote_id/processing'),
  strategy: /* #__PURE__ */ definePathHelper('get', '/broker/prospects/:prospect_id/quotes/:quote_id/strategy'),
  flatAllowances: /* #__PURE__ */ definePathHelper('get', '/broker/prospects/:prospect_id/quotes/:quote_id/flat_allowances'),
  new: /* #__PURE__ */ definePathHelper('get', '/broker/prospects/:prospect_id/quotes/new'),
  edit: /* #__PURE__ */ definePathHelper('get', '/broker/prospects/:prospect_id/quotes/:id/edit'),
  index: /* #__PURE__ */ definePathHelper('get', '/broker/quotes'),
}
